<div class="inspection-data-container">
    <h2 class="section-title">{{ 'pages.inspectionResultsDetail.inspectionData' | translate }}</h2>

    <div class="results-table" *ngIf="displayedInspections.length > 0; else noData">
        <table class="mat-table mat-elevation-z1">
            <thead>
            <tr>
                <th class="name-column"></th>
                <ng-container *ngFor="let inspection of displayedInspections">
                    <th class="data-column">
                        <div>
                            {{ inspection.inspectionDate | localeDate }}
                            <app-custom-popover [index]="inspection.id" title="pages.inspectionItem.notes"
                                                [content]="inspection.notes"
                                                noContentMessage="pages.inspectionItem.no_notes"></app-custom-popover>
                        </div>
                    </th>
                </ng-container>
            </tr>
            </thead>
            <tbody>
            <!-- Inspection input data -->
            <tr>
                <td>{{ 'pages.inspectionResultsDetail.circPercent' | translate }}</td>
                <ng-container *ngFor="let inspection of displayedInspections">
                    <td>{{ inspection.circPercent | localeDecimal }}</td>
                </ng-container>
            </tr>
            <tr>
                <td>{{ 'pages.inspectionResultsDetail.length' | translate }} (mm)</td>
                <ng-container *ngFor="let inspection of displayedInspections">
                    <td>{{ inspection.length | localeDecimal }}</td>
                </ng-container>
            </tr>
            <tr>
                <td>{{ 'pages.inspectionResultsDetail.uncoorThickness' | translate }}</td>
                <ng-container *ngFor="let inspection of displayedInspections">
                    <td>{{ inspection.uncoorThickness | localeDecimal }}</td>
                </ng-container>
            </tr>
            <tr class="editable-row">
                <td>{{ 'pages.inspectionResultsDetail.forcedCR' | translate }} (mm/yr.)</td>
                <ng-container *ngFor="let inspection of displayedInspections">
                    <td>
                        <input
                                type="number"
                                step="0.01"
                                class="force-cr-input"
                                [ngModel]="forcedCRValues[inspection.id]"
                                (ngModelChange)="updateForcedCR(inspection, $event)"
                                [ngClass]="{'highlight': forcedCRValues[inspection.id]}">
                    </td>
                </ng-container>
            </tr>
            </tbody>
        </table>

        <!-- Save Forced CR button -->
        <div class="action-row">
            <button mat-raised-button color="primary" (click)="saveForcedCR()">
                {{ 'pages.inspectionResultsDetail.saveForcedCR' | translate }}
            </button>
        </div>

        <h2 class="section-title">{{ 'pages.inspectionResultsDetail.detailedResult' | translate }}</h2>

        <!-- Second section: Result data -->
        <table class="mat-elevation-z1">
            <tbody>
            <tr>
                <td>{{ 'pages.inspectionResultsDetail.totalSurface' | translate }} (cm2)</td>
                <ng-container *ngFor="let inspection of displayedInspections">
                    <td>{{ inspection.result.totalSurface | localeDecimal }}</td>
                </ng-container>
            </tr>
            <tr>
                <td>{{ 'pages.inspectionResultsDetail.statValidated' | translate }}</td>
                <ng-container *ngFor="let inspection of displayedInspections">
                    <td>{{ inspection.result.statValidated }}</td>
                </ng-container>
            </tr>
            <tr>
                <td>{{ 'pages.inspectionResultsDetail.covThickness' | translate }}</td>
                <ng-container *ngFor="let inspection of displayedInspections">
                    <td>{{ inspection.result.covThickness | percent }}</td>
                </ng-container>
            </tr>
            <tr>
                <td>{{ 'pages.inspectionResultsDetail.maxPitFound' | translate }}</td>
                <ng-container *ngFor="let inspection of displayedInspections">
                    <td>{{ inspection.result.maxPit | localeDecimal }}</td>
                </ng-container>
            </tr>
            <tr>
                <td>{{ 'pages.inspectionResultsDetail.maxExtrPit' | translate }}</td>
                <ng-container *ngFor="let inspection of displayedInspections">
                    <td>{{ inspection.result.maxPitExtrapolated | localeDecimal }}</td>
                </ng-container>
            </tr>
            <tr>
                <td>{{ 'pages.inspectionResultsDetail.minThkFound' | translate }}</td>
                <ng-container *ngFor="let inspection of displayedInspections">
                    <td>{{ inspection.result.minThickness | localeDecimal }}</td>
                </ng-container>
            </tr>
            <tr class="fw-bold">
                <td>{{ 'pages.inspectionResultsDetail.expectedMinThk' | translate }}</td>
                <ng-container *ngFor="let inspection of displayedInspections">
                    <td>{{ inspection.result.minThicknessExtrapolated | localeDecimal }}</td>
                </ng-container>
            </tr>
            <tr>
                <td>{{ 'pages.inspectionResultsDetail.longCR' | translate }} (mm/yr.)</td>
                <ng-container *ngFor="let inspection of displayedInspections">
                    <td>{{ inspection.result.longCorrosionRate | localeDecimal }}</td>
                </ng-container>
            </tr>
            <tr>
                <td>{{ 'pages.inspectionResultsDetail.shortCR' | translate }} (mm/yr.)</td>
                <ng-container *ngFor="let inspection of displayedInspections">
                    <td>{{ inspection.result.shortCorrosionRate | localeDecimal }}</td>
                </ng-container>
            </tr>
            <tr class="fw-bold">
                <td>{{ 'pages.inspectionResultsDetail.statCR' | translate }} (mm/yr.)</td>
                <ng-container *ngFor="let inspection of displayedInspections">
                    <td>{{ inspection.result.statCorrosionRate | localeDecimal }}</td>
                </ng-container>
            </tr>
            <tr>
                <td>{{ 'pages.inspectionResultsDetail.suggestedStrategy' | translate }}</td>
                <ng-container *ngFor="let inspection of displayedInspections">
                    <td>
                        <div [ngClass]="getRecommendationClass(inspection.result.ffsRecommendationCode)"
                             class="recommendation-pill">
                            {{ 'ffsRecommendationCode.' + inspection.result.ffsRecommendationCode | translate }}
                        </div>
                    </td>
                </ng-container>
            </tr>
            </tbody>
        </table>

        <div class="pagination-controls">
            <button mat-icon-button [disabled]="currentPageIndex >= totalPages - 1" (click)="nextPage()">
                <mat-icon>chevron_left</mat-icon>
            </button>
            <span>{{ paginationText }}</span>
            <button mat-icon-button [disabled]="currentPageIndex === 0" (click)="previousPage()">
                <mat-icon>chevron_right</mat-icon>
            </button>
        </div>
    </div>

    <ng-template #noData>
        <div class="no-data">
            {{ 'pages.inspectionResultsDetail.noCompletedInspections' | translate }}
        </div>
    </ng-template>
</div>
